export const getUniqueElements = (elements: any[]) => Array.from(new Set(elements));

export const distinctFilter = (v: any,i: number,a: any[])=> i === a.findIndex(v2=> JSON.stringify(v2) === JSON.stringify(v));